/**
 * Custom Text Section
 * Anima la sección con un fade-in + slide-up cuando entra en el viewport.
 * No hace nada si el navegador no soporta IntersectionObserver
 * o si el usuario tiene activado "reducir movimiento".
 */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  function initSection(section) {
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    observer.observe(section);
  }

  function initAll() {
    var sections = document.querySelectorAll('.custom-text-section');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Soporte para el editor de temas de Shopify (secciones añadidas dinámicamente)
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.custom-text-section');
    if (section) initSection(section);
  });
})();
